<template>
  <luma-empty>
    <b-card >
      <b-button variant="outline-success"
                @click="newNameserver = !newNameserver"
                class="float-right col-12">
        {{newNameserver ? 'Zurück':'Neuen Nameserver Anlegen'}}
      </b-button>
    </b-card>
    <b-card v-if="newNameserver"
            class="text-center">
      <template v-slot:header>
        <h1>Neuen Namserver anlegen</h1>
      </template>
      <div>
        <b-form-group label-cols="4"
                      label-cols-lg="2"
                      label-size="lg"
                      label="Servername"
                      label-for="input-lg">
          <b-form-input id="input-lg"
                        v-model="servername"
                        @input="localChange = true"
                        size="lg">
          </b-form-input>
        </b-form-group>
      </div>
      <b-row class="fixed-bottom footer-summary" v-if="localChange === true">
        <b-col>
          <b-button class="col-12" variant="primary" @click="saveNameserver(), $forceUpdate">
            <h3>Änderungen speichern</h3>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-card v-if="!newNameserver">
      <luma-table v-if="!listChange"
                  url="domain/nameservers"
                  :columns="columns"
                  :model="nameserver" >
        <template v-slot:actions="slotProps">
          <b-link variant="white small" size="xs" @click="deleteNameserver(slotProps.item.servername)" >Löschen</b-link>
        </template>
      </luma-table>
    </b-card>
  </luma-empty>
</template>

<script>
  import LumaEmpty from "@/layout/LumaEmpty";
  import LumaDatatable from "@/components/LumaDatatable";
  import DomainNameserver from "@/store/models/domain/domain_nameserver";
  export default {
    name: "domain-list-nameserver",
    components: {
      LumaEmpty,
      'luma-table': LumaDatatable
    },
    data: () => ({
      newNameserver:false,
      servername:'',
      localChange : false,
      nameserver: DomainNameserver,
      customFilter: null,
      listChange:false
    }),
      computed:{
          columns(){
              const headers = ['servername','addresses','user','actions']
              return headers.map(el=>({
                      key:el,
                      column:el,
                      filter:true,
                      order:true,
                      slot: el === 'actions' ? true : false
                  }
              ))

          }
      },
    methods:{
        saveNameserver(){
            DomainNameserver.create({
                nameserver:this.servername
            })
                .then((response)=> {
                    this.newNameserver = false
                })
                .catch((error)=>error)

        },
        deleteNameserver(name){
            console.log('NAMESERVER',name)
            this.listChange = true
            DomainNameserver.deleten({
                nameserver:name
            })
                .then((response)=>{
                    this.listChange = false
                })
                .catch((error)=>error)
        }
    }
  }
</script>

<style scoped>
  .footer-summary {
    margin-left: 220px;
    z-index: 1000;
    padding: 20px;
    /*height: 85px;*/
    bottom: 0px;
    background: white;
    box-shadow: 0 -1px 5px rgba(0,0,0,.2);
  }

</style>



// WEBPACK FOOTER //
// src/components/domain/domain_nameserver/DomainListNameserver.vue